<template>
  <div class="row">
      <div class="col">
        <Typo>
          <template slot="header">Ihre Ideen sind wichtig</template>
          <template slot="main">Denn sie helfen uns, neue Ziele für Dachau zu erarbeiten</template>
        </Typo>
      </div>
    <div class="col-3-center">
      <h2 class="mt-5 mb-3 text-center">Anmelden</h2>
      <p>Falls Sie noch nicht registriert sind, gehen Sie bitte auf <router-link to="/machmit/registrierung">registrieren</router-link> und legen Sie ein neues Benutzerkonto an.</p>
      <p>Wenn Sie bereits registriert sind, können Sie sich hier mit Ihrem Benutzernamen und Passwort anmelden.</p>
      <Message v-if="$store.state.message&&$store.state.message.location==='login'"/>
      <form>
        <div>
          <label>Benutzername</label><input type="text"
          name="username" v-model="username"
          placeholder="Benutzername"
          >
        </div>
        <div>
          <label>Passwort</label><input type="password" name="password" v-model="password"
          placeholder="Password"
          >
        </div>
        <div class="button-div">
          <button class="primary-bg-color"
          @click.prevent="login"
          :disabled="btnDisabled"
          >Anmelden</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import * as Cookies from "js-cookie";

export default {
  data() {
    return {
      apiUrl:
        process.env.NODE_ENV == "development"
          ? "http://localhost:3000"
          : "https://dachaudenktweiter.de/api",

      btnDisabled: true,
      message: {
        location: "",
        text: "",
        color: ""
      },
      username: "",
      password: "",
      repeatPw: ""
    };
  },
  created() {
    // console.log();
  },
  methods: {
    login() {
      if (!navigator.cookieEnabled) {
        return this.$store.dispatch("setMessage", {
          text:
            "Um sich anmelden zu können, müssen Sie in Ihren Browsereinstellungen Cookies zulassen.",
          color: "red",
          location: "login"
        });
      }
      if (Cookies.get("credentials")) {
        return this.$store.dispatch("setMessage", {
          text: "Sie sind in einem anderen Fenster bereits angemeldet.",
          color: "red",
          location: "login"
        });
      }
      axios
        .post(this.apiUrl + "/user/login", {
          name: this.username,
          password: this.password
        })
        .then(res => {
          if (res.data.message === "auth successful") {
            const credentials = {
              user: res.data.user,
              userId: res.data.userId,
              token: res.data.token,
              date: new Date()
            };
            this.$store.dispatch("setCredentials", credentials);
            this.$router.push("/machmit/karte/user/" + credentials.user);
          } else if (res.data.message === "auth failed") {
            this.$store.dispatch("setMessage", {
              text: "Die Anmeldedaten sind nicht korrekt.",
              color: "red",
              location: "login"
            });
          }
        })
        .catch(() => {
          this.$store.dispatch("setMessage", {
            text:
              "Es konnte keine Verbindung zum Server aufgebaut werden. Bitte versuchen Sie es später noch einmal.",
            color: "red",
            location: "login"
          });
        });
    },
    // Disable Input
    checkInput() {
      if (this.username.length < 6 || this.password.length < 6) {
        this.btnDisabled = true;
      } else {
        this.btnDisabled = false;
      }
    }
  },
  // Disable Input
  watch: {
    username(val) {
      this.checkInput();
    },
    password(val) {
      this.checkInput();
    }
  }
};
</script>

<style scoped lang="scss">
.button-div {
  display: flex;
  justify-content: flex-end;
}
</style>
